import React from 'react';
import TextField from '@mui/material/TextField';

function MaskCpfCnpj(props) {
  const { value, onChange, ...otherProps } = props;

  // Função para aplicar a máscara CPF ou CNPJ com base na quantidade de dígitos
  const applyMask = (inputValue) => {
    if(inputValue){
      const numericValue = inputValue.replace(/[^\d]/g, '');
      if (numericValue.length <= 11) {
        // Aplicar máscara de CPF: 999.999.999-99
        return numericValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } 
      // Aplicar máscara de CNPJ: 99.999.999/9999-99
      return numericValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return ''
  };

  return (
    <TextField
      value={applyMask(value)}
      onChange={(e) => {
        onChange({target: {id: e.target.id , value: e.target.value}});
      }}
      {...otherProps}
    />
  );
}

export default MaskCpfCnpj;
